class ShareButton extends HTMLElement {
  constructor() {
    super();
    
    this.urls = {
      facebook: 'https://www.facebook.com/sharer/sharer.php?u=',
      twitter: 'https://twitter.com/intent/tweet?original_referer=&url=',
      pinterest: "http://pinterest.com/pin/create/button/?url="
    };

    this.buttons = this.querySelectorAll('.social-share');
    this.copyBtns = this.querySelectorAll('.share-button__fallback');
    this.pageUrl = window.location.href;

    //opens social share window
    this.buttons.forEach((button) => {
      button.addEventListener("click", () => {
        let type = button.getAttribute("js-social");
        let url = this.urls[type];

        this.openShareWindow(url, type);
      });
    });

    //copies page url to clipboard
    this.copyBtns.forEach((button) => {
      button.addEventListener("click", () => {
        let linkValue = this.querySelector(".field__input");

        linkValue.select();
        this.copyLink(linkValue.value);
      });
    });
  }

  openShareWindow(url, type) {
    window.open(url + this.pageUrl, `${type}-share-dialog`, 'width=800,height=600');
  }

  copyLink(url) {
    navigator.clipboard.writeText(url);
  }
}

customElements.define('share-button', ShareButton);